import { render } from "./GreenAudioPlayer.vue?vue&type=template&id=0f4cc9b3&scoped=true"
import script from "./GreenAudioPlayer.vue?vue&type=script&lang=js"
export * from "./GreenAudioPlayer.vue?vue&type=script&lang=js"

import "./GreenAudioPlayer.vue?vue&type=style&index=0&id=0f4cc9b3&lang=sass&scoped=true"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4cc9b3"]])

export default __exports__